module.exports = __webpack_public_path__ + "static/media/Profiles.9fabac90.svg";